import shortDate from './filters/shortDate.js';
import longDate from './filters/longDate.js';
import entityToText from './filters/entityToText.js';

/** Use this to define global filters that are of general use **/
export default {
  install(Vue) {
    Vue.filter('shortDate', shortDate);
    Vue.filter('longDate', longDate);
    Vue.filter('entityToText', entityToText);
  }
};
